import { motion, AnimatePresence } from "framer-motion";
import { Star, Wifi } from "lucide-react";

export const Phone = ({ screen = "idle", className = "", businessName = "Your Business" }) => (
  <div
    className={`relative w-[240px] aspect-[9/19] bg-ink rounded-[2.5rem] p-2.5 shadow-[0_30px_70px_rgba(10,10,10,0.35)] ${className}`}
    data-testid="phone-mockup"
  >
    <div className="relative w-full h-full bg-white rounded-[2rem] overflow-hidden">
      <div className="absolute top-2.5 left-1/2 -translate-x-1/2 w-20 h-5 bg-ink rounded-full z-10" />
      <AnimatePresence mode="wait">
        {screen === "idle" && (
          <motion.div
            key="idle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6"
          >
            <div className="w-12 h-12 rounded-full border-2 border-black/10 flex items-center justify-center">
              <Wifi className="w-5 h-5 text-black/30 rotate-90" />
            </div>
            <p className="text-xs text-black/40 text-center font-medium">Ready to tap</p>
          </motion.div>
        )}
        {screen === "nfc" && (
          <motion.div
            key="nfc"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, y: -20 }}
            className="absolute inset-0 bg-ink flex flex-col items-center justify-center gap-4 px-6"
          >
            <motion.div
              initial={{ scale: 0.6 }}
              animate={{ scale: [0.6, 1.1, 1] }}
              transition={{ duration: 0.5 }}
              className="w-14 h-14 rounded-full bg-volt flex items-center justify-center"
            >
              <Wifi className="w-6 h-6 text-white rotate-90" />
            </motion.div>
            <p className="text-white font-display font-bold text-sm">NFC detected</p>
            <p className="text-white/50 text-xs">Opening review page…</p>
          </motion.div>
        )}
        {screen === "review" && (
          <motion.div
            key="review"
            initial={{ opacity: 0, y: 60 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 pt-12 px-5 flex flex-col"
          >
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-mist flex items-center justify-center font-display font-black text-xs text-cardblue">G</div>
              <div>
                <p className="text-[11px] font-bold text-ink leading-tight">{businessName}</p>
                <p className="text-[9px] text-black/40">Google Reviews</p>
              </div>
            </div>
            <p className="font-display font-bold text-sm text-ink mb-3">Rate your experience</p>
            <div className="flex gap-1.5 mb-4">
              {[...Array(5)].map((_, i) => (
                <motion.div
                  key={i}
                  initial={{ scale: 0, rotate: -30 }}
                  animate={{ scale: 1, rotate: 0 }}
                  transition={{ delay: 0.3 + i * 0.12, type: "spring", stiffness: 300 }}
                >
                  <Star className="w-7 h-7 fill-[#F5A623] text-[#F5A623]" />
                </motion.div>
              ))}
            </div>
            <div className="h-16 rounded-lg bg-mist border border-black/5 p-2">
              <p className="text-[9px] text-black/35">Share details of your experience…</p>
            </div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1 }}
              className="mt-4 bg-volt text-white text-center text-xs font-bold py-2.5 rounded-full"
            >
              Post review
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  </div>
);
